import { useParams } from "react-router-dom";
import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";



function InscriptionEdit(props) {  
  let { id } = useParams();  

  return (
    <>
      <edit-inscription inscription-id={id} />
    </>
  );
}

export default injectIntl(withAuth(InscriptionEdit));